export default __webpack_public_path__ + "icon-inferenceef325d.png";